import { ImgHTMLAttributes, useMemo } from "react";
import { Image, Transforms } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";

export function createImageProps(
  image: Image,
  transforms?: Transforms,
  loading?: ImgHTMLAttributes<HTMLImageElement>["loading"]
): ImgHTMLAttributes<HTMLImageElement> {
  return {
    src: transformImageUrl(image, transforms || {}),
    alt: image.altText || "",
    loading,
  };
}

export function useImageProps(
  image?: Image,
  transforms?: Transforms,
  loading?: ImgHTMLAttributes<HTMLImageElement>["loading"]
) {
  return useMemo(
    () => (image ? createImageProps(image, transforms, loading) : null),
    [image, transforms, loading]
  );
}
